import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Star, Reveal, Label } from "../components/primitives";
import { PORTFOLIO, FILTERS } from "../data";

export default function Portfolio() {
  const [filter, setFilter] = useState("All");
  const items = filter === "All" ? PORTFOLIO : PORTFOLIO.filter((p) => p.tag === filter);

  return (
    <div data-testid="portfolio-page">
      <section className="max-w-7xl mx-auto px-6 md:px-12 pt-40 md:pt-52 pb-12 relative z-10">
        <Reveal><Label>Selected work</Label></Reveal>
        <Reveal delay={0.1}>
          <h1 className="font-serif text-6xl md:text-8xl lg:text-9xl font-[200] leading-[0.9] mt-8">
            Portfolio
          </h1>
        </Reveal>
      </section>

      {/* Filters */}
      <section className="max-w-7xl mx-auto px-6 md:px-12 relative z-10 mb-12">
        <div className="flex flex-wrap gap-x-8 gap-y-4 border-b hairline pb-6">
          {FILTERS.map((f) => (
            <button
              key={f}
              data-testid={`filter-${f.toLowerCase().replace(/\s/g, "-")}`}
              onClick={() => setFilter(f)}
              className={`label flex items-center gap-2 transition-colors duration-300 ${
                filter === f ? "text-gold" : "text-white/40 hover:text-white"
              }`}
            >
              {filter === f && <Star size={9} />}
              {f}
            </button>
          ))}
        </div>
      </section>

      {/* Masonry */}
      <section className="max-w-7xl mx-auto px-6 md:px-12 pb-32 relative z-10">
        <motion.div layout className="columns-1 md:columns-2 lg:columns-3 gap-6 [column-fill:_balance]">
          <AnimatePresence mode="popLayout">
            {items.map((p) => (
              <motion.div
                layout
                key={p.id}
                data-testid={`portfolio-item-${p.id}`}
                initial={{ opacity: 0, scale: 0.96 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.96 }}
                transition={{ duration: 0.5, ease: [0.33, 1, 0.68, 1] }}
                className="group mb-6 break-inside-avoid"
              >
                <div className="overflow-hidden border hairline relative">
                  <img
                    src={p.image}
                    alt={p.client}
                    loading="lazy"
                    className={`w-full object-cover grayscale group-hover:grayscale-0 scale-105 group-hover:scale-100 transition-all duration-700 ${
                      p.span === "tall" ? "aspect-[3/4]" : p.span === "wide" ? "aspect-[4/3]" : "aspect-square"
                    }`}
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#0D1220] via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                  <div className="absolute bottom-0 left-0 p-6 translate-y-2 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-500">
                    <p className="font-serif text-2xl">{p.client}</p>
                    <p className="label text-gold mt-1 flex items-center gap-2"><Star size={8} />{p.category}</p>
                  </div>
                </div>
              </motion.div>
            ))}
          </AnimatePresence>
        </motion.div>
      </section>
    </div>
  );
}
